import React, { useState } from 'react';
import { Box, useTheme, useMediaQuery } from '@mui/material';
import AppSidebar from '@/components/AppSidebar/AppSidebar';
import UnifiedHeader from '@/components/UnifiedHeader/UnifiedHeader';
import { User } from '@/models/user';

const SIDEBAR_WIDTH = 240;
const SIDEBAR_COLLAPSED_WIDTH = 64;

interface DashboardLayoutProps {
  user: User;
  onLogout: () => void;
  darkMode: boolean;
  setDarkMode: (v: boolean) => void;
  children: React.ReactNode;
  pageTitle?: string;
  showBackButton?: boolean;
  onBack?: () => void;
}

const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  user, onLogout, darkMode, setDarkMode, children, pageTitle, showBackButton, onBack,
}) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));
  const [sidebarOpen, setSidebarOpen] = useState(!isMobile);
  const [mobileOpen, setMobileOpen] = useState(false);

  const handleSidebarToggle = () => {
    if (isMobile) {
      setMobileOpen((prev) => !prev);
    } else {
      setSidebarOpen((prev) => !prev);
    }
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh' }}>
      <AppSidebar
        open={sidebarOpen}
        onToggle={() => setSidebarOpen((p) => !p)}
        darkMode={darkMode}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />

      <Box
        component="main"
        sx={{
          flexGrow: 1,
          minWidth: 0,
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <UnifiedHeader
          user={user}
          onLogout={onLogout}
          darkMode={darkMode}
          setDarkMode={setDarkMode}
          onSidebarToggle={handleSidebarToggle}
          pageTitle={pageTitle}
          showBackButton={showBackButton}
          onBack={onBack}
        />
        <Box sx={{ pt: '56px', flexGrow: 1 }}>
          {children}
        </Box>
      </Box>
    </Box>
  );
};

export default DashboardLayout;
